import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import ReactECharts from 'echarts-for-react';
import './SubChartPopupPage.css';

function SubChartPopupPage() {
  const location = useLocation();

  const popupData = useMemo(() => {
    const query = new URLSearchParams(location.search);
    const key = query.get('key');
    if (!key) return null;

    try {
      const raw = sessionStorage.getItem(key);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      return parsed;
    } catch (error) {
      console.error('서브차트 팝업 데이터 파싱 실패:', error);
      return null;
    }
  }, [location.search]);

  if (!popupData?.option) {
    return (
      <div className="sub-chart-popup-page">
        <div className="sub-chart-popup-empty">표시할 차트 데이터가 없습니다.</div>
      </div>
    );
  }

  return (
    <div className="sub-chart-popup-page">
      <div className="sub-chart-popup-chart-wrap">
        <ReactECharts
          option={popupData.option}
          style={{ width: '100%', height: '100%' }}
          opts={{ renderer: 'canvas' }}
          notMerge
          lazyUpdate
        />
      </div>
    </div>
  );
}

export default SubChartPopupPage;
